import PropTypes from "prop-types";
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import styles from "./PreviewImage.module.css";
import store from "../../../Store/Store";

const PreviewImage = ({ isVisible, CloseImg, image, name, className = "" }) => {
  const [open, setOpen] = useState(false); // State to handle image expansion
  const [requesting, setRequesting] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [reason, setReason] = useState("Image is Not Clear");

  var logImageEnlarged; //
  var logImageDownloaded; //
  try {
    logImageEnlarged = useDebouncedLog("admin_preview_image", 500);
    logImageDownloaded = useDebouncedLog("admin_downloads_image", 500);
  } catch (err) {
    console.log("error", err);
  }

  const downloadImages = (imageUrl, name) => {
    try {
      const link = document.createElement("a");
      link.href = imageUrl;
      link.setAttribute("download", name);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Image download triggered successfully");
    } catch (error) {
      console.log("Error downloading the image:", error);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const SubmitReuploadrequest = () => {
    let imagename = name;
    console.log("ImageName", imagename);
    console.log("store?.txnId", store?.txnId);
    let newName = imagename.replace(`${store?.txnId}`, "");
    console.log("newName=", newName);

    setRequestSent(true);
  };

  if (!isVisible) return null;
  return (
    <div
      className={styles.previewImageContainer}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={[styles.previewImage, className].join(" ")}>
        <div className={styles.previewImageInner}>
          <div className={styles.img202410288948Parent}>
            <div className={styles.img202410288948}>{name}</div>
            <div className={styles.download01Parent}>
              {(requesting || requestSent) && (
                <button
                  className={styles.xCircle}
                  onClick={() => {
                    try {
                      logImageDownloaded();
                    } catch (err) {
                      console.log("error%o", err);
                    }
                    downloadImages(image, name);
                  }}
                >
                  <img className={styles.icon1} alt="" src="/download-01.svg" />
                </button>
              )}
              <button className={styles.xCircle} onClick={CloseImg}>
                <img className={styles.icon1} alt="" src="/icon1.svg" />
              </button>
            </div>
          </div>
        </div>

        <div className={styles.previewImageChild}>
          <div
            className={styles.previewImageOverlay}
            onClick={() => {
              try {
                logImageEnlarged();
              } catch (err) {
                console.log("error%o", err);
              }
              setOpen(true);
            }}
          >
            Click to Enlarge
          </div>

          <img
            className={styles.frameChild}
            alt=""
            src={image}
            onClick={handleClickOpen}
          />
          {!requestSent && (
            <div className={styles.previewContainerBottom}>
              <div className={styles.bottomButtons}>
                {!requesting && (
                  <button
                    className={styles.bottomButtons1}
                    onClick={() => downloadImages(image, name)}
                  >
                    <img
                      className={styles.icon2}
                      alt=""
                      src="/download-01.svg"
                    />
                    Download
                  </button>
                )}
                {/* <button
                  className={styles.bottomButtons1}
                  onClick={() => {
                    setRequesting(true);
                  }}
                >
                  <img
                    className={styles.icon2}
                    alt=""
                    src="/reuploadResubmit.svg"
                  />
                  Request Bill Resubmit
                </button> */}
              </div>
              {requesting && (
                <div className={styles.bottomcontainer}>
                  <input
                    placeholder="Write reason for request..."
                    className={styles.inputBox}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                  <button
                    className={styles.SubmitButton}
                    onClick={SubmitReuploadrequest}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          )}
          {requestSent && (
            <div className={styles.requestSentContainer}>
              <div className={styles.requestSentHeading}>
                <img
                  className={styles.icon33}
                  alt=""
                  src="/check-circle-blue.svg"
                />
                Request Sent
              </div>
              <div className={styles.requestSentReason}>
                <span className={styles.requestReason}>Reason: </span>
                {reason}
              </div>
            </div>
          )}
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
        <DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              overflow: "auto",
              textAlign: "center",
            }}
          >
            <img
              src={image}
              alt="Expanded"
              style={{
                width: "100%",
                height: "auto",
                cursor: "zoom-out",
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

PreviewImage.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  CloseImg: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default PreviewImage;
